import React from 'react';
import classNames from 'classnames';

import css from './IconOvenMitts.module.css';

/**
 * IconOvenMitts icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconOvenMitts = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.0188 16.5366L7.58758 20.026C8.93345 21.3419 9.60638 21.9998 10.4426 21.9998C10.9565 21.9998 11.4087 21.7513 11.9933 21.2544C12.3511 20.9503 12.53 20.7982 12.5379 20.5779C12.5458 20.3576 12.3693 20.1844 12.0164 19.8379L4.10649 12.0729C3.86619 11.837 3.74603 11.719 3.61375 11.6861C3.52387 11.6638 3.43638 11.666 3.34776 11.6929C3.21732 11.7325 3.10127 11.8587 2.86916 12.111C2.28972 12.741 2 13.2087 2 13.7452C2 14.5628 2.67293 15.2208 4.0188 16.5366Z" fill="#262338"/>
<path d="M20.0792 13.3965C22.6415 10.8913 22.6415 6.82951 20.0792 4.32429C17.5169 1.81908 13.3627 1.81908 10.8004 4.32429L10.335 4.77929C9.91572 3.15159 8.66849 1.97843 7.21395 2.0003C5.44183 2.02694 4.03307 3.81732 4.06738 5.99923L4.03409 9.45651C4.03188 9.67483 4.03078 9.78399 4.06976 9.87822C4.10874 9.97245 4.1852 10.0475 4.3381 10.1976L13.1262 18.8247C13.4564 19.1488 13.6214 19.3109 13.8256 19.3111C14.0297 19.3113 14.1951 19.1496 14.5259 18.8261L20.0792 13.3965Z" fill="#262338"/>
</svg>

  );
};

export default IconOvenMitts;
